import React from 'react'
import { useState,useEffect } from 'react'
import ApiUrl from '../../../../configTools/apiUrl';
import { Link } from 'react-router-dom';

const TopSellerAccounts = () => {
    const Columns = 5;
    const [topUser,setUsers] = useState([]);
    useEffect(()=>{
        fetch(ApiUrl.API_URL_TopSeller)
        .then(res=>res.json())
        .then(data =>{
            setUsers(data);
        });
    },[])
  return (
    <div className='public_home_explore_topsearches'>
        <div className='public_home_user_grid_container'>
            <div className='public_home_product_grid_1_title'>
                <div className='public_home_product_grid_1_title_details'>
                    <h4>{'Top Seller Accounts'}</h4>
                    <p>{'Accounts Most Successful at KAAY'}</p>
                </div>
            </div>
            <div className='public_home_user_grid_users'>
                {
                    topUser.slice(0, parseInt(Columns)).map((user,index)=>{
                        return(
                            <div style={{width:String(95/(parseInt(Columns)))+"%", position:"relative",paddingBottom:"30px"}} key={index}>
                                <div>
                                    <Link to={'/user/'+user.username}>
                                        <div className='public_home_product_grid_1_products_item_container' style={{backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+user.image})`,borderRadius:'10px', overflow:'hidden'}}>
                                            <div className='public_home_product_grid_1_products_item_overlay'></div>
                                        </div>
                                    </Link>
                                    <div className='public_home_product_grid_1_products_item_title'>
                                        <Link to={'/user/'+user.username}><h5>{user.firstname} {user.lastname}</h5></Link>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    </div>
  )
}

export default TopSellerAccounts
